<div class="row">
  <div class="col-120">
    <h1>Users page</h1>
    <ui-users></ui-users>
  </div>

  <div class="col-120 mt-4">
    <ui-user-stores></ui-user-stores>
  </div>

  <div class="col-120 mt-4">
    <ui-user-purchases></ui-user-purchases>
  </div>

  <div class="col-120 mt-4">
    <ui-user-projects></ui-user-projects>
  </div>

  <div class="col-120 mt-4">
    <ui-user-devices></ui-user-devices>
  </div>

  <div class="col-120 mt-4">
    <h1>Products page</h1>
    <ui-products></ui-products>
  </div>

  <div class="col-120 mt-4">
    <h1>Purchases page</h1>
    <ui-purchases></ui-purchases>
  </div>

  <div class="col-120 mt-4">
    <h1>Stores table</h1>
    <ui-stores></ui-stores>
  </div>

  <div class="col-120 mt-4">
    <ui-store-projects></ui-store-projects>
  </div>

  <div class="col-120 mt-4">
    <ui-store-users></ui-store-users>
  </div>

  <div class="col-120 mt-4">
    <ui-store-products></ui-store-products>
  </div>

  <div class="col-120 mt-4">
    <ui-store-collections></ui-store-collections>
  </div>

  <div class="col-120 mt-4">
    <ui-store-actions></ui-store-actions>
  </div>

  <div class="col-120 mt-4">
    <ui-store-versions></ui-store-versions>
  </div>

  <div class="col-120 mt-4">
    <h1>Projects page</h1>
    <ui-projects></ui-projects>
  </div>

  <div class="col-120 mt-4">
    <ui-project-versions></ui-project-versions>
  </div>

  <div class="col-120 mt-4">
    <h1>Store groups page</h1>
    <ui-store-groups></ui-store-groups>
  </div>

  <div class="col-120 mt-4">
    <h1>Moderators page</h1>
    <ui-moderators></ui-moderators>
  </div>
</div>
